import { type ResourceId } from '../common/structs/general';
const competitionsPath = '/competitions';
const getCompetitionUrl = (slug) => `${competitionsPath}/${slug}`;

export const competitions = {
    collection: competitionsPath,
    collectionAvailability: (competitionId: string) => `${competitionsPath}/${competitionId}/check_validity`,
    collections: () => `${competitionsPath}/collections`,
    single: (slug: ResourceId) => {
        const competitionUrl = getCompetitionUrl(slug);
        return {
            competition: competitionUrl,
            leaderBoard: () => `${competitionUrl}/leaderboard`,
            link: () => `${competitionUrl}/link`,
            topCollections: () => `${competitionUrl}/top_collections`,
            recentCollections: () => `${competitionUrl}/recent_collections`,
            freshPick: () => `${competitionUrl}/fresh_pick`,
            freshIdeas: () => `${competitionUrl}/fresh_ideas`,
            wishlists: () => `/wishlists/${slug}`,
            teamLeaderBoard: () => `${competitionUrl}/teams/leaderboard`,
            teams: () => `${competitionUrl}/teams`,
        };
    },
};
